/**
 * A figure sat in lotus — head, arms falling open, legs crossed.
 *
 * Lucide has no meditation glyph, and the stopwatch it lends instead reads as
 * a deadline, which is the opposite of what the timer is for. Drawn to
 * lucide's own metrics (24px box, round joins) so it sits level with the other
 * icons in the menu; the stroke is a hair under 2 because seven strokes in one
 * box close up at the full weight.
 */
export default function MeditationIcon({
    className,
    size,
}: {
    className?: string;
    /** For callers that size icons by prop rather than class, as lucide does. */
    size?: number;
}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width={size}
            height={size}
            fill="none"
            stroke="currentColor"
            strokeWidth="1.9"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            aria-hidden="true"
        >
            <circle cx="12" cy="4" r="2.3" />
            <path d="M12 6.6v7.8" />
            <path d="M12 9c-2.6.5-4.7 2.3-5.9 4.9" />
            <path d="M12 9c2.6.5 4.7 2.3 5.9 4.9" />
            <path d="M12 14.4 4.2 18.4" />
            <path d="M12 14.4 19.8 18.4" />
            <path d="M4.2 18.4h15.6" />
        </svg>
    );
}
